import { api } from '@services';

/**
 * Service for document upload and OCR processing
 */
const documentService = {
  /**
   * Upload a document for OCR processing
   */
  uploadDocument: async (
    file: File,
    hotelId: string,
    documentType: string = 'Miscellaneous Document'
  ): Promise<any> => {
    if (!hotelId) {
      throw new Error('Hotel ID is required');
    }

    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
    if (file.size > MAX_FILE_SIZE) {
      throw new Error(`File size exceeds ${MAX_FILE_SIZE / 1024 / 1024}MB limit`);
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('hotelId', hotelId);
    formData.append('documentType', documentType);

    try {
      const token = localStorage.getItem('token');
      const ocrResponse = await api.post('/ocr/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
        timeout: 300000, // 5 minute timeout for OCR processing
      });

      if (!ocrResponse.data?.structuredData) {
        throw new Error('Invalid OCR response format');
      }

      return ocrResponse.data;
    } catch (error) {
      console.error('OCR Processing Error:', error);
      throw error;
    }
  },

  /**
   * Get OCR results for a hotel
   */
  getOcrResults: async (hotelId: string): Promise<any> => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/ocr/results/${hotelId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching OCR results:', error);
      throw error;
    }
  },

  /**
   * Process and apply OCR results to hotel data
   */
  applyOcrResults: async (hotelId: string, ocrData: any): Promise<any> => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.post(`/ocr/apply/${hotelId}`, ocrData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error('Error applying OCR results:', error);
      throw error;
    }
  }
};

export default documentService;